import type { InvitationRole, InvitationStatus } from "./types";

export const INVITATIONS_QUERY_KEY = ["admin", "invitations"] as const;

/** The API default; its max is 100. */
export const INVITATIONS_PAGE_SIZE = 20;

/** Locations shown inline before the "+N" disclosure. */
export const INVITATIONS_LOCATIONS_INLINE = 2;

export const INVITATION_STATUSES: readonly InvitationStatus[] = [
  "PENDING",
  "EXPIRED",
  "ACCEPTED",
  "DECLINED",
  "REVOKED",
  "SEND_FAILED",
];

export const INVITATION_ROLES: readonly InvitationRole[] = ["ADMIN", "STAFF"];
